import { Page } from '@/core/architecture'

import { ResaleCreatePrecautionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleCreatePrecaution Page
 * Implemented as a practical sample.
 */
export const ResaleCreatePrecaution: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleCreatePrecautionTemplate state={state} {...actions} />
}
